export default __webpack_public_path__ + "media/icons/upload-route-complete-icon-9340bbb3.svg";